module.exports = __webpack_public_path__ + "img/bar-votes.502a1319.png";